const CrabComp = ({ changeColor }) => {
  return (
    <svg viewBox="0 0 492.8 426.05">
      <defs></defs>
      <g id="prefix__Layer_2" data-name="Layer 2">
        <g id="prefix__Layer_1-2" data-name="Layer 1">
          <path
            d="M143.63 321.88c0-14.73-5-43.95 99.17-58 97.8-13.19 107.42 35.7 100.7 54.71a1.68 1.68 0 002.08 2.18c21.6-6.82 14-6.11 24.63-13.91 5.68-4.16-17.76-28.1-17.76-28.1 9.36-13.22-5.52-52.07-5.52-52.07 24-85.12-36.81-81.49-55.37-124.79-14.88-34.71-47.11-43.8-60.74-57.85-6.31-6.5-22-52-61.57-42.15-29.75 7.44-44.74 37.21-38 68.6 5 23.14-24.79 35.54-18.18 79.34 0 0-47.93 111.57 12.4 124.79 0 0-7.44 19-25.62 27.27s-.83 20 21.49 20z"
            onClick={changeColor}
            fill="#1C75BC"
            stroke="#000"
            strokeMiterlimit={10}
            id="hat"
            className="hat"
          />
          <ellipse
            cx={244}
            cy={312.36}
            rx={100.34}
            ry={64.88}
            transform="rotate(-3.69 244.134 312.565)"
            onClick={changeColor}
            fill="#F15A29"
            stroke="#000"
            strokeMiterlimit={10}
            className="body"
            id="body"
          />
          <path
            onClick={changeColor}
            fill="#F15A29"
            stroke="#000"
            strokeMiterlimit={10}
            className="eyelid"
            id="eyelid"
            strokeWidth={1.00004}
            transform="rotate(-8.64 213.239 289.564)"
            d="M204.8 274.71h16.93v29.76H204.8z"
          />
          <path
            onClick={changeColor}
            fill="#F15A29"
            stroke="#000"
            strokeMiterlimit={10}
            className="eyelid"
            id="eyelid"
            strokeWidth={1.00004}
            transform="rotate(-8.64 276.206 279.942)"
            d="M267.15 265.14h18.24v29.76h-18.24z"
          />
          <circle
            cx={209.08}
            cy={263.41}
            r={19.21}
            onClick={changeColor}
            fill="#FFF"
            stroke="#000"
            strokeMiterlimit={10}
            className="eye"
            id="eye"
          />
          <circle
            onClick={changeColor}
            fill="#FFF"
            stroke="#000"
            strokeMiterlimit={10}
            className="eye"
            id="eye"
            cx={269.48}
            cy={254.38}
            r={19.21}
          />
          <path
            onClick={changeColor}
            fill="#F15A29"
            stroke="#000"
            strokeMiterlimit={10}
            className="claw"
            id="claw"
            d="M153.89 325.92c-41.7 3.31-75.59 12.4-88.81 10.74.83.83-67.77-11.94-64.46 30s64.33 10.15 71 0l92.63-30zM338.92 319.67c41.7 3.31 75.59 12.4 88.81 10.74-.83.83 67.77-11.94 64.46 30s-64.33 10.15-71 0l-92.63-30z"
          />
          <path
            onClick={changeColor}
            fill="#F15A29"
            stroke="#000"
            strokeMiterlimit={10}
            className="claw"
            id="claw"
            d="M294.52 355.93c33.47 5.29 59.4 46.19 86 54.91 14.77 4.84 28.9 5.59 34.11-16.28 13.28 13.22 38.12 13.28 45.6-12.05s-57-62.57-110.33-54.17c-32.48-2.87-45.28-8.67-45.28-8.67zM197.32 361.46c-33.06 7.44-56.3 49.92-82.27 60.33-14.43 5.79-28.48 7.44-35.09-14.05-12.4 14.05-37.19 15.7-46.28-9.09s52.89-66.12 106.61-61.16c32.23-5 44.63-11.57 44.63-11.57z"
          />
        </g>
      </g>
    </svg>
  );
};

export default CrabComp;
